<template>
  <div class="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50">
    <div v-tooltip="{ value: t('contact.actions.impersonateStop'), showDelay: 300 }"
         class="is-primary is-large rounded-full has-background-primary p-2 is-size-2
    p-4 hover:text-orange-500 rounded-full cursor-pointer text-white size-dvw"
         @click="stopImpersonation">
      <FontAwesomeIcon
        class="hover:animate-pulse transform transition-transform duration-200"
        :icon="['fas', 'person-to-portal']"
        size="lg"/>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import useImpersonation from '@/app/util/impersonation';

const { t } = useI18n();
const { stopImpersonation } = useImpersonation();

defineProps({
  profile: { type: Object, required: true }
});

</script>
